<ng-container *ngIf="loading">
    <app-loader></app-loader>
</ng-container>

<app-abstract-dialog *ngIf="!loading" [dialogWidth]="'600'">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{ username }} {{ 'USER.SETTINGS' | translate }}</h3>
    </ng-container>

    <ng-container abstract-content>
        <div class="create-user-dialog__content">
            <div class="toggle-settings">
                <div class="toggle-wrapper">
                    <app-slide-toggle
                            [ariaLabel]="'GENERAL.BASIC_MODE' | translate"
                            [labelText]="'GENERAL.BASIC_MODE' | translate"
                            [labelWidth]="'1fr'"
                            [checked]="settings?.basicMode"
                            [settingName]="basicMode"
                            (slideToggleEvent)="change($event)">
                    </app-slide-toggle>
                </div>
                <div class="toggle-wrapper">
                    <app-slide-toggle
                            [ariaLabel]="'GENERAL.ANAMNESIS_QUESTIONNAIRE' | translate"
                            [labelText]="'GENERAL.ANAMNESIS_QUESTIONNAIRE' | translate"
                            [labelWidth]="'1fr'"
                            [disabled]="settings?.basicMode"
                            [checked]="!settings?.anamnesisQuestionnaireOff"
                            [settingName]="anamnesis"
                            (slideToggleEvent)="change($event)">
                    </app-slide-toggle>
                </div>
                <div class="toggle-wrapper" *ngIf="!basicModeEnabled">
                    <app-slide-toggle
                            [ariaLabel]="'GENERAL.SINGLE_QUESTION' | translate"
                            [labelText]="'GENERAL.SINGLE_QUESTION' | translate"
                            [labelWidth]="'1fr'"
                            [checked]="!settings.commentingSingleTypeOff"
                            [settingName]="commenting"
                            (slideToggleEvent)="change($event)">
                    </app-slide-toggle>
                </div>
            </div>

            <div class="additional-settings">
                <div class="additional-settings__select">
                    <div class="select-wrapper">
                        <app-select-menu
                                [disabled]="basicModeEnabled"
                                [labelWidth]="'1fr'"
                                [dropdownWidth]="'240px'"
                                [dropdownHeight]="40"
                                [labelText]="'ONBOARDING.PRESENTATION_MODE.TITLE' | translate"
                                [ariaLabel]="'ONBOARDING.PRESENTATION_MODE.TITLE' | translate"
                                [options]="presentationModeOptions"
                                [selectedId]="selectedPresentationMode"
                                (valueChangeEvent)="onSelectPresentationModeChange($event)">
                        </app-select-menu>
                    </div>
                    <div class="select-wrapper">
                        <app-select-menu
                                [disabled]="basicModeEnabled"
                                [labelWidth]="'1fr'"
                                [dropdownWidth]="'240px'"
                                [dropdownHeight]="40"
                                [labelText]="'ONBOARDING.LANGUAGE_STYLE.TITLE' | translate"
                                [ariaLabel]="'ONBOARDING.LANGUAGE_STYLE.TITLE' | translate"
                                [options]="languageStyleOptions"
                                [selectedId]="selectedLanguageStyle"
                                (valueChangeEvent)="onSelectLanguageStyleChange($event)">
                        </app-select-menu>
                    </div>
                </div>
                <div class="checkbox-wrapper">
                    <app-checkbox
                            [disabled]="basicModeEnabled"
                            [cssClass]="'small'"
                            [checked]="!settings?.lightLanguageStyleOff"
                            [disableRipple]="true"
                            [label]="'DIALOGS.SETTINGS.ALLOW_EASY_LANGUAGE' | translate"
                            [labelPosition]="'after'"
                            (changeEvent)="toggleEasyLanguageOption()">
                    </app-checkbox>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container abstract-footer>
        <div class="button-wrapper">
            <app-button
                    [cssClasses]="'btn full-width solid__blue-07'"
                    (buttonClicked)="onClose()">
                {{'GENERAL.CLOSE' | translate}}
            </app-button>
        </div>
    </ng-container>
</app-abstract-dialog>
